import { render, staticRenderFns } from "./RegistroClave.vue?vue&type=template&id=7c27cf40&"
import script from "./RegistroClave.vue?vue&type=script&lang=js&"
export * from "./RegistroClave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports